// HazardAIDetectionEditButton
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import API, {getMessagesFromApiError} from '../../../api/axios';
import {apiBaseUrl} from '../../../api/urls';

//import {useAppDispatch, useAppSelector} from '../../../hooks/redux';
//import {SafeyeNode} from '../../../interfaces/SafeyeNode';
//import reduxActions from '../../../redux/actions';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  item?: any;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onOpenItem?: Function;
  onOpenHistory?: Function;
  onDone: () => void;
}

const HazardAIDetectionEditButton = <T extends ComponentType = typeof Button>({
  item,
  component,
  componentProps,
  children,
  //onOpenItem,
  //onOpenHistory,
  onDone,
}: Props<T>) => {
  const Component = component ?? Button;
  //const myPermissions = useAppSelector(({app}) => app.me?.permissions);
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement>();
  const menuOpen = !!menuAnchorEl;
  const [falseDetectionModal, setFalseDetectionModal] = useState(false);
  const [removeDetectionModal, setRemoveDetectionModal] = useState(false);
  const [fetchedErrors, setFetchedErrors] = useState<string[]>([]);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    border: '1px solid #9b9b9b',
    boxShadow: 24,
    p: 3,
    overflow: 'auto',
    maxHeight: '100%',
  };

  const markFalseDetection = async () => {
    try {
      await API.patch(`${apiBaseUrl}/hazard-ai/${item.id}/false-detection`);
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, 'STRA_5637b025');
      setFetchedErrors(messages);
    } finally {
      setFalseDetectionModal(false);
      onDone();
    }
  };

  const removeDetection = async () => {
    try {
      await API.delete(`${apiBaseUrl}/hazard-ai/${item.id}/detection`);
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, 'STRA_ca914f7f');
      setFetchedErrors(messages);
    } finally {
      setRemoveDetectionModal(false);
      onDone();
    }
  };

  return (
    <>
      <Component
        {...componentProps}
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
      >
        {children}
      </Component>

      {fetchedErrors.map((error, idx) => (
        <Alert key={idx} severity="error">
          {error}
        </Alert>
      ))}

      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onBackdropClick={() => setMenuAnchorEl(undefined)}
      >
        <MenuItem
          onClick={() => {
            setFalseDetectionModal(true);
            setMenuAnchorEl(undefined);
          }}
          key="hazard_ai_false_detection"
        >
          Mark {item.type === 'detection' ? 'False' : 'Valid'} Detection
        </MenuItem>
        <MenuItem
          onClick={() => {
            setRemoveDetectionModal(true);
            setMenuAnchorEl(undefined);
          }}
          key="hazard_ai_remove_detection"
        >
          Remove Detection
        </MenuItem>
      </Menu>

      <Modal
        open={falseDetectionModal}
        onClose={() => setFalseDetectionModal(false)}
      >
        <Box sx={style}>
          <Typography variant="h6" component="h2" sx={{mb: 2}}>
            Edit Detection
          </Typography>
          <Typography sx={{mb: 3}}>
            Are you sure you want to mark this a{' '}
            {item.type === 'detection' ? 'false' : 'valid'} detection?
          </Typography>
          <ButtonGroup>
            <Button
              onClick={() => {
                setFalseDetectionModal(false);
              }}
            >
              Cancel
            </Button>
            <Button onClick={markFalseDetection} variant="contained">
              Confirm
            </Button>
          </ButtonGroup>
        </Box>
      </Modal>
      <Modal
        open={removeDetectionModal}
        onClose={() => setRemoveDetectionModal(false)}
      >
        <Box sx={style}>
          <Typography variant="h6" component="h2" sx={{mb: 2}}>
            Remove Detection
          </Typography>
          <Typography>
            Are you sure you want to remove this detection?
          </Typography>
          <Button
            onClick={() => {
              setRemoveDetectionModal(false);
            }}
          >
            Cancel
          </Button>
          <Button onClick={removeDetection}>Confirm</Button>
        </Box>
      </Modal>
    </>
  );
};

export default HazardAIDetectionEditButton;
